import { Scale, Shield, Users } from "lucide-react";
import { useTranslation } from "react-i18next";

interface OtherDetailsCardProps {
  profile: any;
}

export function OtherDetailsCard({ profile }: OtherDetailsCardProps) {
  const { t } = useTranslation(["talent", "common"]);

  const formatBoolean = (value: boolean | string) => {
    if (typeof value === "boolean") {
      return value
        ? t("forms.common.boolean.yes")
        : t("forms.common.boolean.no");
    }
    if (typeof value === "string") {
      return value === "yes"
        ? t("forms.common.boolean.yes")
        : t("forms.common.boolean.no");
    }
    return null;
  };

  return (
    <div className="bg-white border rounded-lg p-4 shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <Scale className="h-5 w-5 text-gray-600" />
        <h3 className="font-semibold text-gray-900">Other Details</h3>
      </div>
      <div className="space-y-3">
        {profile.criminal_record && (
          <div className="flex items-center gap-2">
            <Shield className="h-4 w-4 text-gray-600 flex-shrink-0" />
            <span className="text-sm text-gray-600">
              Criminal Record: {formatBoolean(profile.criminal_record)}
            </span>
          </div>
        )}

        {profile.family_reunion !== undefined &&
          profile.family_reunion !== null && (
            <div className="flex items-center gap-2">
              <Users className="h-4 w-4 text-gray-600 flex-shrink-0" />
              <span className="text-sm text-gray-600">
                Family Reunion: {formatBoolean(profile.family_reunion)}
              </span>
            </div>
          )}
      </div>
    </div>
  );
}
